export default [
  {
    path: '/hwBackendRunGuide',
    name: 'HwBackendRunGuide',
    component: () => import('./index.vue'),
    meta: {
      title: '设置引导'
    }
  },
];
